module.exports = __webpack_public_path__ + "static/wine-a282acfadb2cbbe98fbcfc8414f20175.jpg";